var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0977 7.75C14.0977 8.13281 13.7969 8.43359 13.4414 8.43359H4.14453L7.78125 11.8789C8.05469 12.125 8.05469 12.5625 7.80859 12.8086C7.5625 13.082 7.15234 13.082 6.87891 12.8359L2.06641 8.24219C1.92969 8.10547 1.875 7.94141 1.875 7.75C1.875 7.58594 1.92969 7.42188 2.06641 7.28516L6.87891 2.69141C7.15234 2.44531 7.5625 2.44531 7.80859 2.71875C8.05469 2.96484 8.05469 3.40234 7.78125 3.64844L4.14453 7.09375H13.4414C13.8242 7.09375 14.0977 7.39453 14.0977 7.75Z",
    fill: "#001F52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.551670e7f6eb2baa23c5708993d613fb.svg";
export { ForwardRef as ReactComponent };